import { render, staticRenderFns } from "./StudentSelect.vue?vue&type=template&id=038f6f5f"
import script from "./StudentSelect.ts?vue&type=script&lang=ts&external"
export * from "./StudentSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./StudentSelect.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports